module.exports = __webpack_public_path__ + "static/media/ziersch.d2e222b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/ziersch.png
// module id = 394
// module chunks = 0